/**
 * LandingPage - Main entry point
 *
 * Trimmed, focused version for early-stage traction.
 * Hero → How It Works → 3 Differentiators → CTA → Footer
 */

import LandingPageTrimmed from './LandingPageTrimmed';

export default LandingPageTrimmed;
